export default "__VITE_ASSET__CcTL272P__"